import { GridColDef } from "@mui/x-data-grid";

export interface IEmployee {
    id: number;
    name: string;
    employeeCode: string;
    fatherName: string;
    mobileNumber: string;
    email: string;
    status: string;
    division: string;
    dob: string;
    gender: string;
}

export const EMPLOYEE_DETAIL_FIELDS: GridColDef<IEmployee>[] = [
    {
        field: "name",
        headerName: 'Name',
        minWidth: 150
    },
    {
        field: "fatherName",
        headerName: 'Father Name',
        minWidth: 150
    },
    {
        field: 'gender',
        headerName: 'Gender'
    },
    {
        field: 'mobileNumber',
        headerName: 'Mobile Number',
        minWidth: 150
    },
    {
        field: "email",
        headerName: 'Email',
        minWidth: 200,
        renderCell: (params) => {
            const email = params.row.email;
            return email || 'N/A'
        }
    },
    {
        field: "employeeCode",
        headerName: 'Employee Code',
        minWidth: 130
    },
    {
        field: 'status',
        headerName: 'Status'
    },
    {
        field: 'division',
        headerName: 'Division'
    },
    {
        field: 'dob',
        headerName: 'Date of Birth'
    }
]
